module.exports = __webpack_public_path__ + "static/media/overpass1.785bc846.jpg";